import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

import Step1 from "./steps/step-1/step-1";
import Step2 from "./steps/step-2/step-2";
import Step3 from "./steps/step-3/step-3";

import MiniToyCard from "./components/miniToyCard/miniToyCard";
import FinishOrderButton from "./components/finishOrderButton/finishOrderButton";

import { CartContext } from "./../../contexts/cartContext";

import Swal from "sweetalert2";

import api from "../../services/api";

import "./cart.scss";
import { LoadingContext } from "../../contexts/loadingContext";
import { FranchiseContext } from "../../contexts/franchiseContext";
import { useNavigate } from "react-router-dom";
import { AuthUserContext } from "../../contexts/authUserContext";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

function Cart() {
  const { authUser, setAuthUser } = useContext(AuthUserContext);
  const [actualStep, setActualStep] = useState(1);
  const [formData, setFormData] = useState({
    name: authUser?.name,
    email: authUser?.email,
    cpf: authUser?.cpf,
    telefone: authUser?.telefone,
    instagram: authUser?.instagram,
    cep: authUser?.address?.[0]?.postal_code,
    endereco: authUser?.address?.[0]?.street,
    numero: authUser?.address?.[0]?.number,
    complemento: authUser?.address?.[0]?.complement,
    bairro: authUser?.address?.[0]?.district,
    cidade: authUser?.address?.[0]?.city,
    estado: authUser?.address?.[0]?.state,
  });
  const [couponCode, setCouponCode] = useState("");
  const [usedCoupon, setUsedCoupon] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [submitStep3Button, setSubmitStep3Button] = useState(false);
  const { cart, cartSubtotal, cartShippingPrice, removeAllCartItems } = useContext(CartContext);
  const { setIsLoadingGlobal } = useContext(LoadingContext);

  const { franchise } = useContext(FranchiseContext);

  const navigate = useNavigate();

  useEffect(() => {
    calcDiscount();
  }, [cartSubtotal]);

  const cartItemsLength = Object.keys(cart).length;

  function showFormStep() {
    if (actualStep === 1) {
      return <Step1 nextStep={nextStep} formData={formData} />;
    } else if (actualStep === 2) {
      return (
        <Step2 prevStep={prevStep} nextStep={nextStep} formData={formData} />
      );
    } else if (actualStep === 3) {
      return (
        <Step3
          prevStep={prevStep}
          nextStep={nextStep}
          formData={formData}
          onFuncaoDoBotaoExecutada={() => setSubmitStep3Button(true)}
        />
      );
    }

    return <Step1 nextStep={nextStep} />;
  }

  const nextStep = (data) => {
    setFormData(data);
    if (actualStep < 3) {
      setActualStep(actualStep + 1);
    } else {
      setIsLoadingGlobal(true);
      const requestToys = Object.keys(cart).map((key) => {
        return {
          id: key,
          quantity: cart[key].quantity,
          rent_period: cart[key].toy.selectedRental.name
        };
      });

      const requestData = {
        customer: {
          name: data.nomeCartao || data.nome,
          email: data.email,
          phone: data.telefone.replace(/\D/g, ""),
          tax_id:
            data.titularCPF?.replace(/\D/g, "") || data.cpf?.replace(/\D/g, ""),
        },
        toys: requestToys,
        card: {
          number: data.numeroCartao?.replace(/\D/g, ""),
          exp_month: data.mesCartao,
          exp_year: data.anoCartao,
          security_code: data.cvc,
        },
        address: {
          postal_code: data.cep?.replace(/\D/g, ""),
          street: data.endereco,
          number: data.numero,
          district: data.bairro,
          city: data.cidade,
          state: data.estado,
          complement: data.complemento,
          country: "Brasil",
        },
        installments: data.parcelas,
        payment_type: data.pagamento,
        order_shipping_type_code: data.order_shipping_type_code,
        franchise_id: franchise.id,
      };
      api
        .post("buy", requestData)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: `Compra efetuada com sucesso!`,
          });
          removeAllCartItems();
          if (!authUser?.id) {
            const newAuthUser = {
              ...authUser,
              email: data.email,
              name: data.nome,
              cpf: data.cpf,
              id: response.data.user.id,
              address: response.data.user.address[0],
              token: response.data.token
            };
            setAuthUser(newAuthUser);
            localStorage.setItem("authUser", JSON.stringify(newAuthUser));
          }

          if (data.selectedOption === "Pagseguro") {
            navigate("/brinquedos-adoleta");
          } else if (data.selectedOption === "PicPay") {
            navigate("/meus-pedidos");
          } else {
            navigate("/meus-pedidos");
          }
          setIsLoadingGlobal(false);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error!",
            text: "Não foi possível realizar esta transação, por favor contacte a operadora do cartão.",
            icon: "error",
          });
          setIsLoadingGlobal(false);
        });
    }
  };

  const prevStep = () => {
    setActualStep(actualStep - 1);
  };

  function handleShowCartContent() {
    const divFilha = document.querySelector(".head-cart-items");
    const divPai = divFilha.parentElement;

    if (divPai.style.height === "60px") {
      divPai.style.height = "auto";
    } else {
      divPai.style.height = "60px";
    }
  }

  function handleShowCupomContent() {
    const divFilha = document.querySelector(".head-cupom");
    const divPai = divFilha.parentElement;

    if (divPai.style.height === "60px") {
      divPai.style.height = "auto";
    } else {
      divPai.style.height = "60px";
    }
  }

  function handleCouponChange(event) {
    setCouponCode(event.target.value);
  }

  async function handleVerifyCupom(event) {
    event.preventDefault();
    try {
      const response = await api.post("coupons/validate", { code: couponCode });
      Toast.fire({
        icon: "success",
        title: `Cupom ${couponCode} aplicado com sucesso!`,
      });
      const coupon = {
        coupon: couponCode,
        type: response.data.type,
        value: response.data.value,
      };
      setUsedCoupon(coupon);
      calcDiscount(coupon);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "O cupom inserido é inválido!",
        icon: "error",
      });
    } finally {
    }
  }

  const calcDiscount = (coupon = usedCoupon) => {
    if (!coupon) return;
    if (coupon.type === "percentage") {
      setDiscount((cartSubtotal * coupon.value) / 100);
    } else {
      setDiscount(coupon.value);
    }
  };

  function handleSubmitStep3() {
    const buttonSubmitStep3 = document.getElementById("buttonSubmitStep3");

    if (buttonSubmitStep3) {
      buttonSubmitStep3.click();
    }
  }

  return (
    <div className="cart">
      <div className="container-fluid d-flex flex-column gap-3 px-4">
        <div
          className={`d-flex ${isMobile ? "flex-column gap-2 py-3" : "gap-4"
            } align-items-center text-center mb-3 titles`}
        >
          <h1>Carrinho</h1>
          <div
            className="diviser"
            style={isMobile ? { display: "none" } : { display: "block" }}
          ></div>
          <h2>Preencha seus dados para finalizar seu pedido.</h2>
        </div>
        <div className={`d-flex ${isMobile ? "flex-column gap-5" : "gap-4"}`}>
          <div
            className={`form-content w-100 ${isMobile ? "order-2" : "oder-1"}`}
          >
            <div className="d-flex steps">
              <div
                className={`d-flex align-items-center step
                ${actualStep === 1 ? "actual" : ""}
                ${actualStep > 1 ? "active" : ""}
              `}
              >
                <div className="d-flex justify-content-center align-items-center number">
                  1
                </div>
                <h4>Dados de entrega</h4>
              </div>
              <div
                className={`d-flex align-items-center step
                ${actualStep === 2 ? "actual" : ""}
                ${actualStep > 2 ? "active" : ""}
              `}
              >
                <div className="d-flex justify-content-center align-items-center number">
                  2
                </div>
                <h4>Dados pessoais</h4>
              </div>
              <div
                className={`d-flex align-items-center step ${actualStep === 3 ? "actual" : ""
                  }`}
              >
                <div className="d-flex justify-content-center align-items-center number">
                  3
                </div>
                <h4>Forma de pagamento</h4>
              </div>
            </div>
            <div className="form mt-5">{showFormStep()}</div>
          </div>
          <div
            className={`side-container d-flex flex-column gap-3 ${isMobile ? "order-1" : "oder-2"
              }`}
          >
            <div className="box">
              <div className="dropdown-content cart-items p-3">
                <div
                  className="head head-cart-items d-flex justify-content-between"
                  onClick={() => handleShowCartContent()}
                >
                  <h1>Seu carrinho</h1>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div className="toys-items">
                  {cartItemsLength > 0 ? (
                    Object.keys(cart).map((key) => (
                      <MiniToyCard
                        key={cart[key].toy.id}
                        cartItem={cart[key]}
                      />
                    ))
                  ) : (
                    <div className="text-center mt-4">
                      <strong>
                        <em className="empty-text">Seu carrinho está vazio</em>
                      </strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="box">
              <div className="dropdown-content cupom p-3">
                <div
                  className="head head-cupom d-flex justify-content-between"
                  onClick={(e) => handleShowCupomContent()}
                >
                  <h1>Cupom</h1>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div className="form-container mt-3">
                  <form
                    onSubmit={(e) => handleVerifyCupom(e)}
                    className={`form d-flex text-center ${isMobile ? "flex-column gap-3" : "gap-4"
                      }`}
                  >
                    <input
                      type="text"
                      name="cupom"
                      value={couponCode}
                      className="form-control"
                      placeholder="Insira seu cupom"
                      onChange={(e) => handleCouponChange(e)}
                    />
                    <button
                      type="submit"
                      className={`btn-control ${isMobile ? "w-100" : ""}`}
                    >
                      Aplicar
                    </button>
                  </form>
                </div>
                {usedCoupon && (
                  <div className="d-flex flex-column mt-3">
                    <h4>Cupom aplicado</h4>
                    <div className="d-flex mt-3">
                      <span>
                        <b>Código:</b>
                      </span>
                      <span className="ms-auto">{usedCoupon.coupon}</span>
                    </div>
                    {usedCoupon.type === "percentage" && (
                      <div className="d-flex mt-3">
                        <span>
                          <b>Porcentagem:</b>
                        </span>
                        <span className="ms-auto">
                          {usedCoupon.value}%
                        </span>
                      </div>
                    )}
                    <div className="d-flex mt-3">
                      <span>
                        <b>Valor:</b>
                      </span>
                      {usedCoupon.type === "percentage" ?
                        <>
                          <span className="ms-auto">R$ {discount}</span>
                        </>
                        : (<span className="ms-auto">R$ {usedCoupon.value}</span>)}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="box">
              <div className="summary p-3">
                <div className="head-summary mb-3">
                  <h1>Resumo do pedido</h1>
                </div>
                <div className="body-summary d-flex flex-column gap-2 py-3">
                  <div className="item w-100 d-flex justify-content-between">
                    <h4>Subtotal</h4>
                    <h4>
                      <strong>R$ {cartSubtotal}</strong>
                    </h4>
                  </div>
                  <div className="item w-100 d-flex justify-content-between">
                    <h4>Taxa de frete</h4>
                    <h4>
                      <strong>
                        {formData.frete ? (
                          <p className="frete">
                            {formData.frete ? "Grátis" : ""}
                          </p>
                        ) : (
                          <>
                            R$ {cartShippingPrice}
                          </>
                        )}
                      </strong>
                    </h4>
                  </div>
                  <div className="item w-100 d-flex justify-content-between">
                    <h4>Desconto</h4>
                    <h4>
                      <strong>R$ {discount}</strong>
                    </h4>
                  </div>
                </div>
                <div className="footer-summary mt-3">
                  <div className="total w-100 d-flex justify-content-between">
                    <h4>Total</h4>
                    <h4>
                      <strong>R$ {cartSubtotal - discount + cartShippingPrice}</strong>
                    </h4>
                  </div>
                  {actualStep === 3 ? (
                    <FinishOrderButton finishOrder={handleSubmitStep3} />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Cart;
